module.exports = __webpack_public_path__ + "img/product_52.4a4e333.webp";